var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.27101563 -0.01933594 2.54203125 -0.03867187 3.8515625 -0.05859375 C8.89107446 -0.03207 12.82146611 0.04391732 17.375 2.2890625 C19 5.625 19 5.625 19 19.625 C6.46 19.625 -6.08 19.625 -19 19.625 C-19 5.625 -19 5.625 -17.375 2.2890625 C-11.77124268 -0.47390118 -6.15406118 -0.09362162 0 0 Z ",
    fill: "#000000",
    transform: "translate(25,27.375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.00697829 1.53547827 4.53577667 2.61886352 5.62890625 5.87109375 C6.27092057 9.44609981 6.21701031 11.50087629 4.75 14.875 C3 17 3 17 0 19 C-4.50611509 19.43607565 -6.9048259 19.55923784 -10.9375 17.5 C-13.70951682 14.13997961 -14.30911988 11.31909172 -14 7 C-11.18221735 0.51909991 -6.79210309 -1.03271743 0 0 Z ",
    fill: "#000000",
    transform: "translate(29,3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6196b0e3fee8193b5f6abd4e9089ff1f.svg";
export { ForwardRef as ReactComponent };